/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {useThemeMode} from '../../../../../../_metronic/partials';
import css from '../../../../../../styles/TOPManagers.module.scss';
import classNames from 'classnames';
import {useStore} from '../../../../../../store/store';
import {observer} from 'mobx-react';
import imagePlug from '../../../../../../_metronic/assets/media/user.png';
import {Link} from 'react-router-dom';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {formatNumberToCash, formatNumber} from '../../../../../functions/formatNumber';

const ManagerIcons = ({data}) => {
  return (
    <>
      {!!data?.is_verified && (
        <OverlayTrigger
          delay={{hide: 450, show: 300}}
          placement='right'
          overlay={(props) => (
            <Tooltip className='fs-8' {...props}>
              {!!data?.verify_date ? `Верифицирован ${data?.verify_date}` : 'Time not set'}
            </Tooltip>
          )}
        >
          <div className='d-md-block d-none symbol symbol-30px symbol-circle'>
            <span>
              <i className='ki-duotone ki-verify fs-1 text-primary'>
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
            </span>
          </div>
        </OverlayTrigger>
      )}
      {!!data?.is_ban && (
        <OverlayTrigger
          delay={{hide: 450, show: 300}}
          placement='right'
          overlay={(props) => (
            <Tooltip className='' {...props}>
              {!!data?.ban_date ? `Заблокирован ${data?.ban_date}` : 'Time not set'}
            </Tooltip>
          )}
        >
          <div className='d-md-block d-none symbol symbol-30px symbol-circle'>
            <span>
              <i className='text-danger ki-duotone ki-lock-3 fs-1'>
                <span className='path1'></span>
                <span className='path2'></span>
                <span className='path3'></span>
              </i>
            </span>
          </div>
        </OverlayTrigger>
      )}
    </>
  );
};

const Stats = ({data}) => {
  return (
    <div className={classNames(css.stats, css.rdStats)}>
      <div className={classNames(css.appeals, css.separator)}>
        <div className='d-flex justify-content-center align-items-center'>
          <div className='d-flex justify-content-center align-items-center flex-column'>
            <span className='text-gray-900 fw-bold d-block mb-1 fs-6 text-center'>
              {formatNumber(data?.qualifications_count)}
            </span>
            <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
              Квалификации
            </span>
          </div>
        </div>
      </div>
      <div className={classNames(css.registrations, css.separator)}>
        <div className='d-flex justify-content-center align-items-center'>
          <div className='d-flex justify-content-center align-items-center flex-column'>
            <span className='text-gray-900 fw-bold d-block mb-1 fs-6 text-center'>
              {formatNumber(data?.deposits_count)}
            </span>
            <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
              Депозиты
            </span>
          </div>
        </div>
      </div>
      <div className={css.qualifications}>
        <div className='d-flex justify-content-center align-items-center'>
          <div className='d-flex justify-content-center align-items-center flex-column'>
            <span className='text-gray-900 fw-bold d-block mb-1 fs-6 text-center'>
              {formatNumberToCash(data?.deposits_amount)}
            </span>
            <span className='text-muted fw-semibold text-muted d-block fs-7 text-center text-nowrap'>
              Сумма депозитов
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const TeamInfo = ({data, compact, canOpenTeam}) => {
  const content = (
    <>
      <span
        className={classNames(
          'text-gray-900 text-hover-primary fw-bold mb-1 fs-6 cursor-pointer',
          compact && 'text-center'
        )}
      >
        {compact ? data?.team?.id && `#${data?.team?.id}` : `${data?.team?.teamleader?.first_name || ''} ${data?.team?.teamleader?.last_name || ''}`}
      </span>
      {!compact && (
        <span className='text-muted fw-semibold text-muted d-block fs-7'>
          {data?.team?.id && `#${data?.team?.id}`}
        </span>
      )}
      {compact && <span className='text-muted fw-semibold text-muted d-block fs-7'>Команда</span>}
    </>
  );

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex justify-content-start flex-column'>
        {canOpenTeam && data?.team?.id ? (
          <Link to={`/sales/rd/teams/${data?.team?.id}`}>{content}</Link>
        ) : (
          content
        )}
      </div>
    </div>
  );
};

const Item = ({data, top, bad}) => {
  const store = useStore();
  const theme = useThemeMode();

  const [mode, setMode] = useState('');
  const [openSub, setOpenSub] = useState(false);

  const canOpenTeam = !(
    store.roles.includes(15) ||
    store.roles.includes(17) ||
    store.roles.includes(34)
  );
  const averageCheckTitle =
    data?.is_top_eligible === false ? 'Сумма депозитов ниже 500$, в топе не участвует' : 'Средний чек';

  useEffect(() => {
    if (theme.mode === 'system') {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        setMode('dark');
      } else {
        setMode('light');
      }
    } else {
      setMode(theme.mode);
    }
  }, [theme]);

  return (
    <li className={css.item}>
      <div
        className={css.blockScreen}
        style={{
          backgroundColor: mode === 'light' ? 'rgb(255, 255, 255)' : '#15171C',
          border: mode === 'light' ? '1px solid rgb(241, 241, 244)' : 'none',
        }}
      >
        <div
          className={classNames(
            css.position,
            top[0] === data?.id && css.gold,
            top[1] === data?.id && css.silver,
            top[2] === data?.id && css.bronze,
            bad.includes(data?.id) ? css.bad : ''
          )}
        >
          <span className={classNames('text-gray-900 fw-bold fs-6 text-center')}>
            {data.place === 99999 ? '-' : data.place}
          </span>
        </div>
        <div className={css.user}>
          <div className='d-flex align-items-center'>
            <div className={classNames('symbol symbol-45px me-5')}>
              <img
                className='object-fit-cover'
                src={data?.avatar ? `${process.env.REACT_APP_API_HOST}/${data?.avatar}` : imagePlug}
                style={{borderRadius: '50%'}}
                alt=''
              />
            </div>
            <div className='d-flex justify-content-start flex-column'>
              <div className='d-flex align-items-center'>
                <span className='text-gray-900 fw-bold mb-1 fs-6 text-nowrap'>
                  {data?.first_name} {data?.last_name}
                </span>
                <ManagerIcons data={data} />
              </div>
              <span className='text-muted fw-semibold text-muted d-block fs-7'>
                #{data?.id}
                <span
                  className={classNames(
                    `badge badge-light-${data?.status?.indicator} ms-2 fs-7 fw-bold`,
                    css.userLtc
                  )}
                >
                  {formatNumberToCash(data?.players_avg_amount)}
                </span>
              </span>
            </div>
          </div>
        </div>
        <div className={classNames(css.info, css.screenInfo)}>
          {!!data?.team?.id && (
            <>
              <div className={css.team}>
                <TeamInfo data={data} canOpenTeam={canOpenTeam} />
              </div>
              <div className={css.teamMobile}>
                <TeamInfo data={data} compact canOpenTeam={canOpenTeam} />
              </div>
            </>
          )}
          <Stats data={data} />
        </div>
        <div className={css.ltc}>
          <OverlayTrigger
            delay={{hide: 450, show: 300}}
            placement='top'
            overlay={(props) => (
              <Tooltip className='fs-8' {...props}>
                {averageCheckTitle}
              </Tooltip>
            )}
          >
            <span className={`badge badge-light-${data?.status?.indicator} fs-7 fw-bold`}>
              {formatNumberToCash(data?.players_avg_amount)}
            </span>
          </OverlayTrigger>
        </div>
        <div className={css.action}>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-light btn-active-light-primary toggle h-25px w-25px'
            onClick={() => setOpenSub(!openSub)}
          >
            {!openSub && <i className='ki-duotone ki-plus fs-3 m-0'></i>}
            {!!openSub && <i className='ki-duotone ki-minus fs-3 m-0'></i>}
          </button>
        </div>
      </div>
      <div
        className={classNames(css.blockMobile, !!openSub && css._active)}
        style={{
          backgroundColor: mode === 'light' ? 'rgb(255, 255, 255)' : '#15171C',
          border: mode === 'light' ? '1px solid rgb(241, 241, 244)' : 'none',
        }}
      >
        <div className={css.info}>
          <Stats data={data} />
        </div>
      </div>
    </li>
  );
};

export default observer(Item);
